import apiClient from '../connections/api'

export default {
    createUser: (userData, password) => {
        const requestBody = {
            ...userData,
            password
        }
        return apiClient.post('/users/createUser', requestBody)
    },
    editUser: (userData, id) => {
        const requestBody = {
            userData,
            id
        }
        return apiClient.post('/users/editUser', requestBody)
    },
    createSign: (sign) => {
        return apiClient.post('/users/create-sign', { sign })
    },
    getAllUsers: () => {
        return apiClient.get('/users')
    },
    getMantenedores: (admin) => {
        return apiClient.post('/users/getMantenedores', { admin: admin })
    },
    getOperadores: (admin) => {
        return apiClient.post('/users/getOperadores', { admin: admin })
    },
    getUser: (id) => {
        return apiClient.get(`/users/${id}`)
    },
    removeUser: (id) => {
        return apiClient.delete(`/users/${id}`)
    },
    findByRut: (rut) => {
        const requestBody = {
            rut
        }
        return apiClient.post('/users/findByRut', requestBody)
    },
    findByRole: (role) => {
        const requestBody = {
            role
        }
        return apiClient.post('/users/findByRole', requestBody)
    },
    getUserSign: (id) => {
        return apiClient.get(`/users/${id}/sign`)
    },
    activateUser: (email) => {
        const requestBody = {
            email
        }
        return apiClient.post('/users/activate-user', requestBody)
    },
    getUsersByRole: (roleName) => {
        return apiClient.get(`/users/byRole/${roleName}`)
    },
    resetPassword: (id) => {
        return apiClient.post(`/users/${id}/reset-password`)
    },
    migrateUsersToSite: (fromSiteId, toSiteId) => {
        return apiClient.post('/users/migrate-users-to-site', {
            fromSiteId,
            toSiteId
        })
    },
    updateProfile: (userData) => {
        return apiClient.post('/users/updateProfile', userData)
    }
}
